<template>
  <div>
    <list :sendType="sendType" :system="system"></list>
  </div>
</template>

<script>
import list from "../currency/list";
export default {
  components: {
    list,
  },
  data() {
    return {
      sendType: 1,
      system:"representative",
      //职工代表大会
    };
  },
};
</script>

<style lang="stylus" type="stylesheet/stylus" scoped></style>